import React from 'react';
import MainApp from './MainApp';
import PublicPressKit from './components/PublicPressKit/PublicPressKit';

// Check if this is a public press kit route
const getPublicPressKitId = () => {
  const path = window.location.pathname;
  // Match /presskit/ID or /app/presskit/ID
  const match = path.match(/\/presskit\/([a-z0-9]+)/i);
  return match ? match[1].toLowerCase() : null;
};

export default function App() {
  const publicId = getPublicPressKitId();
  
  // If this is a press kit route, render the public component
  if (publicId) {
    return <PublicPressKit publicId={publicId} />;
  }

  // Otherwise render the main app
  return <MainApp />;
}
